/**
 * 🏗️ FSD Shared Layer - Activity Utils
 * 
 * ActivityPage에서 사용되는 점수 관련 유틸리티 함수들
 */ /**
 * 점수에 따른 등급 판정
 */ export var getScoreGrade = function(score) {
    if (score >= 90) return {
        label: '탁월함',
        className: 'text-green-600 dark:text-green-400'
    };
    if (score >= 80) return {
        label: '우수함',
        className: 'text-blue-600 dark:text-blue-400'
    };
    if (score >= 70) return {
        label: '양호함',
        className: 'text-cyan-600 dark:text-cyan-400'
    };
    if (score >= 60) return {
        label: '보통',
        className: 'text-yellow-600 dark:text-yellow-400'
    };
    return {
        label: '개선 필요',
        className: 'text-red-600 dark:text-red-400'
    };
};
